import React from 'react';
import { portfolioData } from '../mockData';
import { useTheme } from '../hooks/useTheme';

const Nav = () => {
  const { personal } = portfolioData;
  const { theme, toggleTheme } = useTheme();

  return (
    <nav>
      <a className="nav-name" href="#hero">{personal.name}</a>
      <div className="nav-right">
        <a href="#expertise">Expertise</a>
        <a href="#projects">Projects</a>
        <a href="#experience">Experience</a>
        <button className="theme-btn" onClick={toggleTheme} id="theme-btn">
          {theme === 'dark' ? ': Light :' : ': Dark :'}
        </button>
      </div>
    </nav>
  );
};

export default Nav;
